module.exports = __webpack_public_path__ + "72871854aabdd7a79c4fc5038cb4faaf.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/css/Barlow-Bold.ttf
// module id = 1535
// module chunks = 1